export enum InstagramState {
  CONNECT_ADMIN = 'CONNECT_ADMIN',
  CONNECT_USER = 'CONNECT_USER',
  LOGIN = 'LOGIN',
  USERNAME = 'USERNAME'
}
